<template> 
  <v-card width="375" flat class="details-sdd mx-auto">
    <back-button v-if="!singlePaymentMethod" @click="$emit('abort')" :disabled="loader"/>
    
    <div>
      <v-form ref="form" v-model="formValid">
        <p class="pageTitle">{{$t('info_account')}}</p>
        <input-field 
          v-model="email"
          :label="$t('email')"
          :placeHolder="$t('placeholder_email')"
          :rules ='rules.email'/>
        <phone-input ref="phoneNumberInput"
          v-model='phoneNumber'
          :label="$t('phone')"
          :optional="!phoneRequired"
          @update="updatePhoneNumber"
          />
        <input-field
          v-normalize
          v-model="firstName"
          :label="$t('first_name')"
          :rules ='rules.name'/>
          <!-- :tooltip="$t('info_enterprise_name')" -->
        <input-field
          v-normalize
          v-model="name"
          :label="$t('name')"
          :rules ='rules.name'/>
          <!-- :tooltip="$t('info_enterprise_name')" -->
        <input-field
          v-normalize
          v-model="companyName"
          :label="$t('enterprise')"
          :rules ='rules.enterprise_optional'
          optional/>
        <!-- <div class="userLink">
          <a @click="isPro = true">{{$t('click_enterprise')}}</a>
        </div> -->
        <input-field 
          v-model="iban"
          :label="$t('iban')"
          :rules ='ibanRules'
          :placeHolder="$t('placeholder_iban')"
          v-mask="'AANN NNNN NNNN NNNN NNNN NNNN NNNN NNNN NNNN NNNN'"
          @errorupdate="onIbanErrorUpdate"
          :isLoading="loadingDisplayOptions">
        </input-field>
        <div class="infoConditions d-flex">
          <img class="align-self-start mr-1" src="@/assets/information-outline.svg"/>
          <div>{{$t('info_conditions_sdd')}}</div>
        </div>
        <template>
        <!-- <template v-if="ibanHorsEU"> -->
          <div class="pl-1 mt-5 inputFieldLabel asterisk">{{$t('country_debtor')}}</div>
          <v-select v-model='country' 
            :items="translatedSepaCountries" 
            item-text="translatedName" 
            item-value="name" 
            :rules='rules.country'
            hide-details="auto"
            solo
            class="mt-1 mb-5"
            outlined
            flat
            append-icon="$chevrondown"
            :placeholder="$t('placeholder_country')">
            <template v-slot:prepend-inner>
              <country-flag :country='country ? getCountryAlpha2() : ""' :rounded='true' class="country-flag"/>
            </template>
          </v-select>
          <input-field
            v-model="address"
            :label="$t('address_debtor')"
            :rules ='rules.address'/>
          <input-field
            v-model="address2"
            :label="$t('address2_debtor')"
            :optional="true"
            :rules ='rules.address_optional'
          />
          <div class="d-flex">
            <input-field 
              v-model="postalCode"
              :label="$t('postalCode')"
              @blur="validatePostalCode"
              :error-messages="postalCodeErrors"
              :showRequirementLabels="false"
              class="mr-2"/>
            <input-field 
              v-model="city"
              :label="$t('city')"
              :rules ='rules.city'
              :showRequirementLabels="false"/>
          </div>
          <input-field  v-if="showProvince"
            v-model="province"
            :label="$t('province')"
            :rules ='rules.province'/>
        </template>
        <check-box
          class="saveInfoCheck"
          v-model="saveAlias"
          hideDetails dense
          :disabled="forceSaveAlias">
          <template v-slot:label>
            <div>
              <div :class='{ "mb-4": !saveAlias }'>{{ $t('save_banking_info') }}</div>
              <div v-if='saveAlias' class='mt-8'>{{ $t('save_banking_info_label') }} :</div>
            </div>
          </template>
        </check-box>
        <input-field
          v-if='saveAlias'
          v-model="newAliasLabel"
          :label="''"
          :rules ='saveAlias ? rules.aliasLabel_optional : []'
          :disabled="!saveAlias"
          class="ml-6 mt-n3"/>
      </v-form>
    </div>

    <v-card-actions class="pa-0">
      <ConfirmButton 
        :disabled="!canConfirm"
        :isLoading="loader"
        @click="confirm"
        class="icon-button">
        <span>{{$t('confirm_information')}}</span>
        <img class="button-icon" src="@/assets/arrow-forward-outline.svg"/>
      </ConfirmButton>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { VCard, VCardActions, VForm, VSelect } from 'vuetify/lib'
  import ConfirmButton from '@/components/ConfirmButton'
  import BackButton from '@/components/BackButton'
  import validationRules from '../../../mixins/validationRules'
  import validationPostalCode from '../../../mixins/validationPostalCode'
  import RequestHandler from '@/views/payment/mixins'
  import sddMixin from './sddMixin'
  import valueMappings from '@/mixins/valueMappings'
  import InputField from '@/components/InputField.vue'
  import CheckBox from '@/components/CheckBox'
  import PhoneInput from '@/components/PhoneInput'
  import CountryFlag from 'vue-country-flag'
  import testData from '../testData'
  import {mapState} from 'vuex'

  export default {
    name: 'PaymentDetailSDD',
    mixins: [validationRules, validationPostalCode, valueMappings, RequestHandler, sddMixin],
    components: { VCard, VCardActions, VForm, BackButton, ConfirmButton, CheckBox, VSelect, InputField, CountryFlag, PhoneInput },
    props: {
      params: {
        type: Object,
        default: () => ({})
      }
    },
    methods: {
      confirm: function () {
        this.loader = true
        setTimeout(() => {
          let data = { 
            email: this.email,
            iban: this.iban.replace(/\s/g, ''),
            bic: this.bic,
            socialReason: this.companyName,
            firstName: this.firstName,
            lastName: this.name
          }
          if (this.saveAlias) {
            data.registerAlias = '1'
            data.aliasLabel = this.newAliasLabel
          }
          if (this.phoneNumberData.isValid) data.phoneNumber = '00' + this.phoneNumberData.countryCallingCode + this.phoneNumberData.nationalNumber
          
          //Defect 128694
          // if (this.ibanHorsEU) {
            Object.assign(data, {
              address: this.address,
              address2: this.address2,
              city: this.city,
              postalCode: this.postalCode,
              country: this.getCountryAlpha3(this.country),
              province: this.province
            })
          // }
          this.$emit('confirm', data)
        }, 1000)
      },
      updatePhoneNumber: function (data) {
        this.phoneNumberData = data
      },
      onIbanErrorUpdate: function (error) {
        this.ibanValid = !error
      },
      getDisplayOptions: function (iban) {
        if (this.loadingDisplayOptions) {
          this.repeatDemand = true
          return
        }

        let unformatted = iban.replace(/\s+/g, '')
        if (this.lastCheckedIban === unformatted) return
        this.lastCheckedIban = unformatted

        this.loadingDisplayOptions = true
        this.callSDDDisplayOptions({
          iban: this.iban.replace(/\s/g, ''),
          paymentMethodTypeId: this.params.methodTypeId,
          paymentMethodId: this.params.methodId
        }).then(rep => {
          setTimeout(() => {
            if (process.env.NODE_ENV !== 'production') {
              this.testcount++
              let mockData = this.testcount % 3 === 0 ? testData.displayOptions : testData.displayOptions
              this.ibanUnknown = mockData.statusCode === '1'
              this.bic = mockData.bic
              this.phoneRequired = mockData.otp === '1'
              this.loadingDisplayOptions = false
            }
            else {
              if (!rep) throw new Error(this.$t('error_displayoptions'))
              const content = rep.content
              if (content.statusCode === '0') {
                this.ibanUnknown = false
                this.bic = content.bic
                this.phoneRequired = content.otp === '1'
              }
              else {
                this.ibanUnknown = true
                this.bic = ''
              }
              this.loadingDisplayOptions = false
            }

            if (this.repeatDemand) {
              this.repeatDemand = false
              this.getDisplayOptions(this.iban)            
            }
          }, 200)
        })
      }
    },
    computed: {
      ...mapState(['singlePaymentMethod']),
      ibanHorsEU: function () {
        return (this.iban.length > 1 && this.bic && this.bic.length > 5) ? this.isIbanHorsEU(this.iban.slice(0,2), this.bic.slice(4,6)) : false
      },
      showProvince: function () {
        let country = this.sepaCountries.find(i => i.name === this.country)
        if (country) return country.hasProvince
        return false
      },
      translatedSepaCountries: function () {
        let translated = this.sepaCountries.map(i => {
          i.translatedName = this.$t(i.name)
          return i})
          translated = translated.sort((a, b) => a.translatedName.localeCompare(b.translatedName))
          const fr = translated.find(x => x.name === 'France')
          return [fr, ...translated.filter(x => x.name !== 'France')]
      },
      canConfirm: function () {
        if (this.loadingDisplayOptions) return false
        else return this.formValid && (this.phoneNumberData.isValid || (!this.phoneRequired && !this.phoneNumberData.nationalNumber))
      }
    },
    watch: {
      country: {
        handler: function (newValue) {
          this.onCountryUpdated(this.getCountryID(newValue))
        },
        immediate: true
      },
      postalCode: {
        handler: function (newValue) {
          this.onPostalCodeUpdated(newValue)
        },
        immediate: true
      },
      iban: {
        handler: function (newValue) {
          this.ibanUnknown = false
          this.lastCheckedIban = ''
          setTimeout(() => {
            if (newValue && this.ibanValid) this.getDisplayOptions(newValue)
          }, 200)
        }
      },
      ibanValid: {
        handler: function (newValue) {
          setTimeout(() => {
            if (newValue && this.iban) this.getDisplayOptions(this.iban)
          }, 200)
        }
      }
    },
    data: function () {
      return {
        formValid: false,
        email: '',
        phoneNumber: '',
        phoneNumberData: { isValid: false, nationalNumber: '' },
        phoneRequired: false,
        iban: '',
        ibanValid: false,
        ibanUnknown: false,
        bic: '',
        name: '',
        firstName: '',
        companyName: '',
        address: '',
        address2: '',
        postalCode: '',
        city: '',
        country: '',
        province: '',
        saveAlias: false,
        newAliasLabel: '',
        loader: false,
        testcount: 0,
        loadingDisplayOptions:false,
        repeatDemand: false,
        lastCheckedIban: ''
      }
    }
  }
</script>